// Region detection: India (IST timezone) → INR / Razorpay, rest of world → USD / Paddle.
// Strict timezone-only detection: only Asia/Kolkata or Asia/Calcutta count as IN.
// Locale and currency hints are intentionally ignored per product decision.
import { useState } from "react";

export type Region = "in" | "intl";

export function detectRegion(): Region {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (tz === "Asia/Kolkata" || tz === "Asia/Calcutta") return "in";
  } catch { /* ignore */ }
  return "intl";
}

export function useRegion(): Region {
  const [region] = useState<Region>(() => detectRegion());
  return region;
}
